{
  "CallControlMcError": "Beim Versuch, eine Verbindung herzustellen, ist ein Fehler aufgetreten",
  "CallControlActionError": "Beim Ausführen der Aktion ist ein Fehler aufgetreten",
  "CallControlCompleteTransferError": "Beim Abschließen der Übertragung ist ein Fehler aufgetreten",
  "CallControlPickupCallError": "Beim Annehmen des Anrufs ist ein Fehler aufgetreten",
  "CallControlChangingDndError": "Beim Ändern des DND-Status für ist ein Fehler aufgetreten",
  "CallControlConnectionUpdate": "Beim Verbindungsupdate ist ein Fehler aufgetreten",
  "CallControlDeletePhantom": "Beim Versuch, den Phantomanruf zu löschen, ist ein Fehler aufgetreten.",
  "CallControlAcdStatusUpdate": "Bei der ACD-Statusaktualisierung ist ein Fehler aufgetreten",
  "CallControlMonitoringActionError": "Beim Überwachen der Aktion ist ein Fehler aufgetreten",
  "CallControlUserInfoMissing": "Benutzerinformationen fehlen. Dies könnte darauf hindeuten, dass Sie nicht mehr authentifiziert sind. Bitte versuchen Sie sich ab- und wieder anzumelden.",
  "CallControlTelPartDevError": "Telefonieserver, Partition, Agent oder Gerät waren nicht verfügbar.",
  "NAME": "CallControlErrors",
  "CallControlSetAccountCode": "Beim Einstellen des Kontocodes ist ein Fehler aufgetreten"
}